<!-- =========================================================================================
  File Name: RoleEdit.vue
  Description: Role Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Rol no encontrado" :active.sync="id_not_found">
      <span>Datos de rol con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'roles'}" class="text-inherit underline"> todos los roles</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="data_local" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <div class="w-full">
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Código de rol" v-model="data_local.role" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Descripción" v-model="data_local.description" :enabled="editing"/>
              </div>
              <div class="w-full mt-2 mb-4">
                <ejs-treegrid
                  ref="options"
                  :dataSource="options"
                  :treeColumnIndex="1"
                  locale='es-GT'
                  :toolbar='toolbarOptions'
                  height="400px"
                  childMapping="options"
                  :recordDoubleClick="showPermissions"
                >
                  <e-columns>
                    <e-column field="id" :visible="false" :isPrimaryKey="true"/>
                    <e-column field="name" headerText="Acceso a opciones de menú"/>
                    <e-column field="permissions" headerText="Permisos asignados" :template="cTemplate" permissions="permissions"/>
                  </e-columns>
                </ejs-treegrid>
                <!--                <ejs-treeview :fields="{ dataSource: this.data_local.options, id: 'id', parentID: 'parentId', text: 'name', hasChildren: 'hasChildren' }" :showCheckBox="true"></ejs-treeview>-->
              </div>
            </div>
          </div>

        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vs-prompt
      :active.sync="isPermissionsActiveLocal"
      @accept="savePermissions"
      @cancel="cancel"
      accept-text="Aceptar"
      cancel-text="Cancelar"
      :title="`Permisos para opción ${optionName}`"
    >
      <div>
        <ejs-listview ref="permissions" :dataSource='permissionsOption' showCheckBox='true'></ejs-listview>
      </div>
    </vs-prompt>

  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')

  import Vue from "vue";
  import {L10n, setCulture} from '@syncfusion/ej2-base';
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {TreeGridPlugin, Toolbar, Filter} from '@syncfusion/ej2-vue-treegrid';
  import {ListViewPlugin} from '@syncfusion/ej2-vue-lists';
  import CellRendererPermissions from '@/views/infra/cell-renderer/CRPermissions';

  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'treegrid': {
        'EmptyRecord': 'No se encontraron opciones',
        'Search': 'Buscar',
        'Excelexport': 'Exportar'
      }
    }
  });

  Vue.use(TextBoxPlugin);
  Vue.use(TreeGridPlugin);
  Vue.use(ListViewPlugin);

  export default {
    data() {
      return {
        fields: {dataSource: this.options, id: 'id', parentID: 'parentId', text: 'name', hasChildren: 'hasChildren'},
        toolbarOptions: ['Search'],
        loaded: false,
        editing: false,
        id: 0,
        locations: [],
        data: null,
        permissions: [],
        permissionsOption: [],
        options: [],
        data_local: {
          id: 0,
          role: '',
          description: ''
        },
        id_not_found: false,
        isPermissionsActive: false,
        optionName: '',
        optionId: 0,
        cTemplate: function () {
          return {template: CellRendererPermissions};
        }
      }
    },
    provide: {
      treegrid: [Toolbar, Filter]
    },
    computed: {
      isPermissionsActiveLocal: {
        get() {
          return this.isPermissionsActive
        },
        set(val) {
          if (val) {
            this.permissionsOption = [];
          } else {
            this.$emit('closePermissions');
          }
        }
      }
    },
    methods: {
      reset_data() {
        if (this.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'roles'});
        }
      },
      pushOption(option) {
        var options = [];
        if (option.options != null) {
          for (var i = 0; i < option.options.length; i++) {
            options.push(this.pushOption(option.options[i]));
          }
        }
        return {
          id: option.id,
          name: option.name,
          slug: option.slug,
          validPermissions: option.validPermissions,
          permissions: option.permissions,
          options: options
        };
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            this.$http.post(deltaPOS_config.default.apiURL + '/roles/data', {id: id, context: this.$store.state.AppActiveUser}).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
                // self.options = JSON.parse(JSON.stringify(response.data.data.options));
                self.options = [];
                for (var i = 0; i < response.data.data.options.length; i++) {
                  if (response.data.data.options[i].parentId == 0) {
                    self.options.push(self.pushOption(response.data.data.options[i]));
                  }
                }
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      getOptionPermissions(id, options) {
        var permissions = '';
        for (var i = 0; i < options.length; i++) {
          if (permissions == '') {
            if (options[i].id == id) {
              permissions = options[i].permissions;
            } else if (options[i].options) {
              permissions = this.getOptionPermissions(id, options[i].options);
            }
          }
        }
        return permissions;
      },
      setOptionPermissions(id, options, permissions) {
        for (var i = 0; i < options.length; i++) {
          if (options[i].id == id) {
            options[i].permissions = permissions;
          } else if (options[i].options) {
            this.setOptionPermissions(id, options[i].options, permissions);
          }
        }
      },
      showPermissions(row) {
        if (this.editing) {
          this.optionId = row.rowData.id;
          var self = this;
          var permissions = this.getOptionPermissions(this.optionId, this.data_local.options);
          this.optionName = row.rowData.name;
          this.permissionsOption = [];
          this.permissions.forEach(function (item) {
            if (row.rowData.validPermissions.includes(item.code)) {
              self.permissionsOption.push({text: item.name, id: item.code, isChecked: permissions.includes(item.code)});
            }
          });
          this.isPermissionsActive = true;
        }
      },
      savePermissions() {
        var permissions = '';
        this.$refs.permissions.getSelectedItems().data.forEach(function (item) {
          permissions += (permissions == '' ? '' : ',') + item.id;
        });
        if (!permissions.includes('ACC')) {
          permissions = '';
        }
        this.setOptionPermissions(this.optionId, this.data_local.options, permissions);
        this.$refs.options.setCellValue(this.optionId, 'permissions', permissions);
        this.$refs.options.refresh();
        this.isPermissionsActive = false;
      },
      cancel() {
        this.isPermissionsActive = false;
      },
      validateForm() {
        var message = '';
        if (!this.data_local.role || this.data_local.role == '') {
          message = 'Debe especificar un código';
        } else if (!this.data_local.description || this.data_local.description == '') {
          message = 'Debe especificar una descripción';
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error al guardar rol',
            text: message,
            color: 'danger'
          });
        }
        return (message == '');
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de rol',
            type: 'point'
          });
          var self = this;
          this.data_local.id = this.id;
          this.data_local.context = this.$store.state.AppActiveUser;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(deltaPOS_config.default.apiURL + '/roles/save', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos del rol fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'role', params: {id: response.data.data.id}});
              }
              this.editing = false;
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar rol "${this.data.description}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando rol',
          type: 'point'
        });
        var self = this;
        this.$http.post(deltaPOS_config.default.apiURL + '/roles/delete', {id: this.id, context: this.$store.state.AppActiveUser}).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información eliminada',
              text: 'Rol fue eliminado correctamente',
              color: 'primary'
            });
            self.$router.push({name: 'roles'});
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.editing = false;
          this.$vs.loading.close();
        });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando rol',
          type: 'point'
        });
      }
      var self = this;
      this.$http
        .post(deltaPOS_config.default.apiURL + '/infra/permissions/list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token})
        .then(response => {
          if (response.data.success) {
            self.permissions = response.data.data;
            // for (var i = 0; i < response.data.data.length; i++) {
            //   self.permissions.push(response.data.data[i].code);
            // }
          }
          self.getData(self.id);
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-vue-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
  @import "../../../../node_modules/@syncfusion/ej2-grids/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-treegrid/styles/material.css";
  @import "../../../../node_modules/@syncfusion/ej2-vue-lists/styles/material.css";

  .wrapper {
    max-width: 250px;
    margin: 0 auto;
  }

  .e-grid .e-altrow {
    background-color: #fafafa;
  }

  #avatar-col {
    width: 12rem;
  }

  #page-stock-warehous-edit {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: .4rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }
  }

</style>
